<script setup>
// Vue
import { storeToRefs } from 'pinia'
import { computed, provide, ref, onBeforeMount, watch, onMounted } from 'vue'
import { useRouter, useRoute } from 'vue-router'

// Store
import { useLearningAuthStore } from '@stores/auth'
import { useAppManagerStore } from '@stores/appManager'

// Utility
import { iosSupportVh } from '@utils'

// Component
import Header from '@components/layouts/Header.vue'
import Footer from '@components/layouts/Footer.vue'
import WaitingAsyncActions from '@components/WaitingAsyncActions.vue'

import learningApi from '@src/services/api/learning/index'

const { failedRefreshTokenResult } = useAppManagerStore()
const { accessToken, deviceToken, userLogging } = storeToRefs(useLearningAuthStore())
const { updateAccessToken, resetAuth } = useLearningAuthStore()

learningApi.setContext({
  route:useRoute(),
  router:useRouter(),
  failedRefreshTokenResult,
  accessToken,
  deviceToken,
  updateAccessToken,
  resetAuth,
  failedRefreshTokenResult,
  userLogging,
})

iosSupportVh()
const route = useRoute()

const isShownContentsLoading = ref(false)
const openContentsLoading = () => { isShownContentsLoading.value = true }
const closeContentsLoading = () => { isShownContentsLoading.value = false }

const isShownWaitingAsyncActions = ref(false)
const openWaitingAsyncActions = () => { isShownWaitingAsyncActions.value = true }
const closeWaitingAsyncActions = () => { isShownWaitingAsyncActions.value = false }

// This App Component Methods
const rootAppProvide = ref({
  openContentsLoading,
  closeContentsLoading,
  openWaitingAsyncActions,
  closeWaitingAsyncActions,
  contentsMainScrollY: 0 // これは任意で利用するオプション
})
watch(route, () => {
  rootAppProvide.value.pageName = route.name
  rootAppProvide.value.pageMeta = route.meta
}, { immediate: true })

provide('rootAppProvide', rootAppProvide)
const observeContentsMainScroll = (event) => {
  rootAppProvide.value.contentsMainScrollY = event.target.scrollTop
}

// Layout Flags
const isUseHeader = computed(() => {
  return route.meta.header !== false
})
const isUseFooter = computed(() => {
  return route.meta.footer !== false
})

onMounted(async () => {
  // accessTokenが無ければrouter/indexでオープニング画面に自動遷移
})
</script>

<template>
  <div class="wrapper">
    <div class="contents">
      <div class="contents__body">
        <Header
          v-show="isUseHeader"
          class="contents__header"
        />
        <main
          class="contents__main"
          :class="userLogging ? 'loggined' : ''"
          @scroll="observeContentsMainScroll"
        >
          <RouterView></RouterView>
        </main>
        <Footer
          v-show="isUseFooter"
          class="contents__footer"
        />
      </div>
    </div>
    <div id="modalPosition" />
    <div id="overlayPosition" />
    <WaitingAsyncActions
     :show="isShownContentsLoading"
    />

  </div>
</template>

<style scoped lang="scss">
.wrapper{
  position: relative;
  height: calc(var(--vh, 1vh) * 100);
}

.contents{
  position: relative;
  display: flex;
  height: calc(var(--vh, 1vh) * 100);

  &__body{
    position: relative;
    width: 100vw;
  }

  &__main{
    transition: opacity 0.25s;
    position: relative;
    overflow-y: auto;
  }
}

.contents__body{
  z-index: 1;

  .contents__main{
    z-index: 1;
    position: relative;
    padding-top: 131px;
  }

  .contents__footer{
    z-index: 1;
  }
}

#modalPosition{
  position: relative;
  z-index: 2;
}

#moverlayPosition{
  position: relative;
  z-index: 2;
}

.routerBefore{
  opacity: 0;
}

.routerAfter{
  opacity: 1;
}

@media (max-width: 992px) {
  .contents__body{

    .contents__main{
      padding-top: 131;

      &.loggined{
        padding-top: 50px;
      }
    }
  }
}
</style>
